import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Mail, X } from "lucide-react";

export default function NudgePreviewButton() {
  const [html, setHtml] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/emails/preview/weekly_nudge");
      setHtml(data.html);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not load preview");
    }
    setBusy(false);
  };

  return (
    <>
      <button
        data-testid="nudge-preview-btn"
        onClick={load}
        disabled={busy}
        className="mt-3 w-full text-slate-600 hover:text-slate-900 text-sm font-semibold flex items-center justify-center gap-2 transition-colors disabled:opacity-60"
      >
        <Mail size={14} /> {busy ? "Loading…" : "Preview this week's recap"}
      </button>

      {html && (
        <div className="fixed inset-0 z-50 bg-slate-900/70 backdrop-blur-sm flex items-end sm:items-center justify-center" data-testid="nudge-preview-modal">
          <div className="w-full max-w-md bg-white rounded-t-3xl sm:rounded-3xl max-h-[85vh] overflow-hidden flex flex-col shadow-2xl">
            <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 sticky top-0 bg-white">
              <div className="text-sm font-semibold text-slate-900">Sunday recap preview</div>
              <button data-testid="nudge-preview-close" onClick={() => setHtml(null)} className="w-8 h-8 rounded-full hover:bg-slate-100 flex items-center justify-center transition-colors" aria-label="Close"><X size={16} /></button>
            </div>
            <iframe title="Weekly nudge preview" srcDoc={html} className="flex-1 w-full border-0" />
          </div>
        </div>
      )}
    </>
  );
}
